import { SplitMenuButtonWebElementBase } from './SplitMenuButtonWebElementBase';
import { byCss } from '@oracle/oraclejet-testing/UNSAFE_Locators';
import { findButton } from '@oracle/oraclejet-preact/UNSAFE_Button/testing';
import { By } from 'selenium-webdriver';
import { getTestElement } from '../../../webdriver/PRIVATE_preact-webdriver';

/**
 * The component WebElement for [oj-c-split-menu-button](../../jsdocs/oj-c.SplitMenuButton.html).
 * Do not instantiate this class directly, instead, use
 * [findSplitMenuButton](../functions/findSplitMenuButton.html).
 */
export class SplitMenuButtonWebElement extends SplitMenuButtonWebElementBase {
  // Put overrides here

  /**
   * Perform a click on the button action
   */
  override async click() {
    // Find the action part of <button> element top element
    return findButton(byCss('[role=button] span:first-child'), getTestElement(this)).doAction();
  }

  /**
   * Perform a click on the button
   */
  doAction() {
    return this.click();
  }

  /**
   * Helper util
   * */

  private async findAsyncSequential<T>(
    array: T[],
    predicate: (t: T) => Promise<boolean>
  ): Promise<T | undefined> {
    for (const t of array) {
      if (await predicate(t)) {
        return t;
      }
    }
    return undefined;
  }

  /**
   * Fire the ojMenuAction event on the oj-c-split-menu-button, and
   * invoke the Action handler of the selected value.
   *
   */
  public async doMenuAction(selectedValue: string | string[]): Promise<void> {
    // open the menu
    await this.openMenu();
    if (Array.isArray(selectedValue)) {
      for (const value of selectedValue) {
        await this.doMenuClick(value);
      }
    } else {
      await this.doMenuClick(selectedValue);
    }
  }

  /**
   * openMenu - opens the menu
   */
  private async openMenu() {
    return findButton(byCss('span[role=none]:last-child'), getTestElement(this)).doAction();
  }

  /**
   * delay - delays the milliseconds
   * await delay(2000);
   */
  // private delay = (ms: number) => new Promise((fn) => setTimeout(fn, ms));
  private delay = (ms: number) => new Promise((fn) => setTimeout(fn, ms));

  /**
   * In order to do nested selections, we need an isolated menu clicker
   */
  private async doMenuClick(selectedValue: string): Promise<void> {
    // Find the <menu-item> element to click
    await this.delay(350);
    const menuItems = await this.getDriver().findElements(
      By.css('#__root_layer_host [role^=menuitem], #__oj_zorder_container [role^=menuitem]')
    );

    const match = await this.findAsyncSequential(menuItems, async (item) => {
      const text = await item.getText();
      return text === selectedValue;
    });

    await match?.click();
  }
}
